module.exports = __webpack_public_path__ + "img/quote-top.46e31996.svg";